import { COUNTIES } from '@/data/homeContent';
import { DeliveryCalculator } from '@/features/delivery/DeliveryCalculator';

export const DeliveryTeaser = () => (
  <section id="szallitas" aria-labelledby="szallitas-cim" className="scroll-mt-24 bg-sand-soft py-16 sm:py-20">
    <div className="mx-auto w-full max-w-[1220px] px-4 sm:px-6">
      <div className="mx-auto mb-8 max-w-[56ch] text-center">
        <h2 id="szallitas-cim" className="text-2xl">
          Mennyi lesz a szállítás?
        </h2>
        <p className="mt-3 text-ink-soft">
          Adja meg az irányítószámot vagy a települést, és megmutatjuk a várható költséget. A területen kívüli
          címekre is jövünk, egyedi megállapodással.
        </p>
      </div>

      <ul className="mb-8 flex list-none flex-wrap justify-center gap-2.5 p-0">
        {COUNTIES.map((county) => (
          <li key={county} className="rounded-full bg-sand px-5 py-1.5 text-sm font-semibold text-navy">
            {county}
          </li>
        ))}
      </ul>

      <DeliveryCalculator className="mx-auto max-w-[760px]" />
    </div>
  </section>
);
